import { observer } from 'mobx-react-lite'
import { CollapseWithIcon } from 'shared/ui'
import { type Integration } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { IntegrationPipedriveSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationPipedriveSettings/store/IntegrationPipedriveSettingsStore'
import { IntegrationPipedriveSettingsSync } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationPipedriveSettings/ui/IntegrationPipedriveSettingsSync/IntegrationPipedriveSettingsSync'
import { CollapseIntegrationSettingsTimeline } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsTimeline/CollapseIntegrationSettingsTimeline'
import { CollapseIntegrationSettingsProperty } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsProperty/CollapseIntegrationSettingsProperty'
import { CollapseIntegrationSettingsUsers } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsUsers/CollapseIntegrationSettingsUsers'
import sharedStyles from 'pages/settings/pages/integrations/pages/integrationSettings/ui/styles.module.scss'

type IIntegrationPipedriveProps = {
  integration: Integration
}

export const IntegrationPipedriveSettings = observer<IIntegrationPipedriveProps>(
  ({ integration }) => {
    const entities = useEntitiesContext()
    const { collapseStore, userStore, syncStore, propertyStore, timelineStore } =
      useIntegrationStoreMemo(IntegrationPipedriveSettingsStore, integration, entities)

    return (
      <div>
        <CollapseIntegrationSettingsUsers collapseStore={collapseStore} userStore={userStore} />
        <CollapseWithIcon
          opened={collapseStore.opened('sync')}
          onClick={collapseStore.onToggle('sync')}
          icon={'arrowHorizontalOutline'}
          title={'Contact syncing'}
          label={syncStore.getLabel}
          headerClassName={sharedStyles.collapseWithIcon}
        >
          <IntegrationPipedriveSettingsSync store={syncStore} />
        </CollapseWithIcon>
        <CollapseIntegrationSettingsProperty
          collapseStore={collapseStore}
          propertyStore={propertyStore}
          is_1_0_request={true}
        />
        <CollapseIntegrationSettingsTimeline
          collapseStore={collapseStore}
          name={integration.name}
          dailyBundles={timelineStore.dailyBundles}
          onDailyBundlesToggle={timelineStore.onDailyBundlesToggle}
        />
      </div>
    )
  }
)
